import { TransactionStatus } from '@/features/Transactions/transactions.types'
import { DateTime, Interval } from 'luxon'

export function formatSolanaPublicKey(publicKey: string, cutNumber: number = 4): string {
  if (!publicKey) {
    return '...'
  }
  const start = publicKey.slice(0, cutNumber)
  const end = publicKey.slice(-cutNumber)
  return `${start}****${end}`
}

export function getLastFour(pan: string) {
  if (!pan) return ''
  return pan.slice(-4)
}

export function capitalizeFirstLetter(text: string) {
  if (!text) return text // Check if the string is empty or null
  return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1)
}

export function parseDateWithStatus(timestamp: string, status: string) {
  const dt = DateTime.fromISO(timestamp)
  const diff = dt.diffNow(['minute', 'minutes', 'hours', 'day', 'days'], {
    conversionAccuracy: 'longterm',
  })

  const isFailed = status === TransactionStatus.FAILED
  const isErrored = status === TransactionStatus.ERROR_SEND
  const statusText = isFailed ? 'Declined' : isErrored ? 'Canceled' : capitalizeFirstLetter(status)

  const daysBetween = Interval.fromDateTimes(dt, DateTime.now()).toDuration('days').days
  const hoursBetween = Interval.fromDateTimes(dt, DateTime.now()).toDuration('hours').hours
  const minutesBetween = Interval.fromDateTimes(dt, DateTime.now()).toDuration('minutes').minutes

  if (minutesBetween < 1) {
    return 'Just now'
  }

  if (hoursBetween < 1) {
    return `${Math.abs(Math.round(diff.toObject().minutes))} min ago`
  }

  if (hoursBetween > 1 && hoursBetween < 24) {
    return `${Math.abs(Math.floor(diff.toObject().hours))} hours ago`
  }

  if (daysBetween >= 1 && daysBetween < 2) {
    return 'Yesterday'
  }

  return dt.toFormat('dd MMM y')
}

export function parseDateWithTime(timestamp: string) {
  const dt = DateTime.fromISO(timestamp)
  return dt.toFormat('HH:mm')
}

export function isDateString(value: string): boolean {
  const date = new Date(value)
  return !Number.isNaN(date.getTime())
}

export function formatCardNumber(cardNumber: string) {
  return cardNumber.replace(/(\d{4})(?=\d)/g, '$1 ')
}
